module.exports = fox._r("images/octoberfest/gift-133.png", __webpack_public_path__ + "_/_/_/_/common/liveshow/images/octoberfest/gift-133.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/images/octoberfest/gift-133.png
// module id = 334
// module chunks = 4